import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AwsRum, AwsRumConfig } from 'aws-rum-web';

try {
  const config = {
    sessionSampleRate: 1 ,
    endpoint: "https://dataplane.rum.us-west-2.amazonaws.com" ,
    telemetries: ["errors","http"] ,
    allowCookies: true ,
    enableXRay: false ,
    signing: false // If you have a public resource policy and wish to send unsigned requests please set this to false
  };

  const APPLICATION_ID = 'a121fb90-25ee-4ddb-abf3-360e638e3222';
  const APPLICATION_VERSION = '1.0.0';
  const APPLICATION_REGION = 'us-west-2';

  const awsRum = new AwsRum(
    APPLICATION_ID,
    APPLICATION_VERSION,
    APPLICATION_REGION,
    config
  );
} catch (error) {
  // Ignore errors thrown during CloudWatch RUM web client initialization
}

ReactDOM.render(
  <BrowserRouter>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </BrowserRouter>
  , document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

